import React from 'react';
import { Row, Col } from 'antd';
import Link from 'next/link';
import styled from 'styled-components';
import { SectionTitle } from 'components/Section';
import Image from 'components/Image';

const ImageContainer = styled.div`
    @media (min-width: 768px) {
        position: absolute;
        margin-top: -100px;
        margin-left: auto;
        margin-right: auto;
        left: 50%;
        transform: translateX(-50%);
    }
`;

const InfoText = styled.p`
    font-size: 23px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.93;
    letter-spacing: normal;
    text-align: left;
    @media (max-width: 768px) {
        padding-top: 10px;
        text-align: center;
    }
    color: ${({ theme }) => theme.colors.greyishBrownTwo};
`;

const BuyText = styled.span`
    font-size: 26px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 36px;
    letter-spacing: normal;
    text-align: left;
    @media (max-width: 768px) {
        text-align: center;
    }
    color: ${({ theme }) => theme.colors.greyishBrownTwo};
`;

const Section = styled(Row)`
    margin: 50px 0;
    padding: 25px;
    background: #f4f4f4;
    height: 173px;
    @media (max-width: 768px) {
        height: auto;
        text-align: center;
    }
`;

interface Props {
    issue: Issue;
}

const Subscription = ({ issue }: Props): JSX.Element => (
    <Section align="middle" justify="center">
        <Col xs={24} md={8}>
            <SectionTitle title="PRENUMERATA" url="/prenumerata" />
        </Col>
        <Col xs={24} md={8}>
            <ImageContainer>
                <Link href={`/prenumerata`}>
                    <Image
                        type="issue"
                        height={200}
                        width={141}
                        src={issue.cover}
                        alt={issue.name}
                    />
                </Link>
            </ImageContainer>
        </Col>
        <Col sm="auto" md={8}>
            <InfoText>Chcesz otrzymać nasze czasopismo?</InfoText>
            <Link href="/prenumerata">
                <BuyText>Zamów prenumeratę</BuyText>
            </Link>
        </Col>
    </Section>
);

export default Subscription;
